// TODO (Nick 2026.04.29) - move this decompression logic to the backend so responses arrive already decompressed
import { captureException } from '@sentry/browser';
import decompressGzipBody from './decompressGzipBody';

export default function decompressGzipBase64(base64Data) {
  if (!base64Data) {
    return '';
  }

  try {
    const binaryString = window.atob(base64Data);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return decompressGzipBody(bytes);
  } catch (error) {
    captureException(error);
    return '';
  }
}
